import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";
import OrderStatus from "@/pages/OrderStatus";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/pagamento/sucesso" element={<PaymentResult />} />
          <Route path="/pagamento/cancelado" element={<PaymentResult />} />
          <Route path="/pedido/:id" element={<OrderStatus />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
